import { CircularProgress, CircularProgressProps } from "@mui/material";

export const LoadingIcon = ({ className, ...props }: CircularProgressProps) => {
  return <CircularProgress className={className} {...props} />;
};
